/**
 * Afterpay支付配置
 * afterpay支付对金额的要求是 >10
 * 所选货币为（AUD, CAD, NZD, USD）中的任意一种
 */
export const afterpayEssentialMap = {
  AUD: 'AU',
  CAD: 'CA',
  USD: 'US',
  NZD: 'NZ',
};

/**
 * Klarna支付配置
 * ■ 10≤商品金额≤1000（美元）
 * ■ 10≤商品金额≤1500（欧元）
 * ■ 30≤金额≤1000（英镑）
 */
export const klarnaEssentialMap = {
  USD: {
    CURRENCY: 'USD', // 币种
    MIN: 10, // 最小值
    MAX: 1000, // 最大值
    CYCLE: 4, // 分期期数
  },
  GBP: {
    CURRENCY: 'GBP',
    MIN: 30,
    MAX: 1000,
    CYCLE: 3,
  },
  EUR: {
    CURRENCY: 'EUR',
    MIN: 10,
    MAX: 1500,
    CYCLE: 3,
  },
};
